import React, {useState, useRef, useEffect, useCallback} from "react";
import './KYCNoItem.scss'
import CustomAlert from "../../../UI/CustomAlert/CustomAlert";
import { Box, Button, Typography, Dialog, DialogContent, DialogActions, Divider, Autocomplete, TextField, Slider, Chip } from "@mui/material";
import { useSelector } from "react-redux";
import PinPad from "../../../PinPad/PinPad";
import captureImage from "../../../../images/capture-image.svg";
import uploadImage from "../../../../images/upload-image.svg";
import { getKYCTypes } from "../../../../util/API/KYC_legacy";
import { Crop, RotateLeft, RotateRight, ZoomIn } from "@mui/icons-material"
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

function KYCNoItem({ docType, docname, uploadPhoto, uploadLoading}) {
    const [selectedBase64Image, setSelectedBase64Image] = useState(null);
    const [doctype, setDoctype] = useState(docType);
    const [idNum, setIdNum] = useState("");
    const [newDocType, setNewDocType] = useState("");
    const [alert, setAlert] = useState({
        showAlert: false, 
        severity: '',
        message: '',
        header: ''
      });
    const [position, setPosition] = useState({ x: 0, y: 0 });
    const [dragging, setDragging] = useState(false);

    const dragStartRef = useRef({ x: 0, y: 0 });
    const fileInputRef = useRef(null);
    const imageRef = useRef(null);
    const containerRef = useRef(null);

    const [showPinPad, setShowPinPad] = useState(false);
    const [showCamera, setShowCamera] = useState(false);
    const [cameraTimeout, setCameraTimeout] = useState(null);
    const [countdown, setCountdown] = useState(120); 
    const [kycTypes, setKYCTypes] = useState([]);
    const [selectedKYCType, setSelectedKYCType] = useState({});
    const [previewDialogOpen, setPreviewDialogOpen] = useState(false);
    const [rotation, setRotation] = useState(0);
    const [zoom, setZoom] = useState(1);

    const [cropMode, setCropMode] = useState(false)
    const [cropArea, setCropArea] = useState({ x: 150, y: 150, width: 300, height: 300 })
    const [resizing, setResizing] = useState(null)
  
    const [isEditing, setIsEditing] = useState(false);
    const [tempOriginalImage, setTempOriginalImage] = useState(null);

    const [facingMode, setFacingMode] = useState("user");

    const videoRef = useRef(null);
    const canvasRef = useRef(null);

  let pin = sessionStorage.getItem("pin");
  let agent = JSON.parse(sessionStorage.getItem("user")).payload?.body;
  const pinConfiguration = useSelector((state) => state.login.pinConfiguration);

  // console.log(pinConfiguration)
  // console.log(docname)
  // console.log(doctype)
  // console.log(uploadLoading)

  useEffect(() => {
    const KYCTypes = async () => {
      try {
        const response = await getKYCTypes();
        // console.log(response);

        const defaultTypes = [
          {
            key: "select",
            value: "select",
            label: "Select a document"
          },
        ]
  
        // Extract the array from the response
        const data = response.payload.body.record;
  
        // Transform the data into an array of key-value-label objects
        const keyValueLabelArray = data.map((item) => {
          const key = item.domainattributes.domainatt;
          const value = item.domainattributes.attname; // Adjust if you need a different value
          const label = item.domainattributes.attname;
  
          return { key, value, label };
        });
  
        // Update the state with the transformed data
        setKYCTypes([...defaultTypes, ...keyValueLabelArray]);
      } catch (error) {
        console.log(error);
      }
    };
  
    KYCTypes();
  }, []);

  useEffect(() => {
    setSelectedKYCType(kycTypes.find((type) => type.value === docname || type.value === "select"));
  }, [kycTypes])

  useEffect(() => {
    if (dragging) {
      window.addEventListener("mousemove", handleMouseMove);
      window.addEventListener("mouseup", handleMouseUp);
      window.addEventListener("touchmove", handleMouseMove);
      window.addEventListener("touchend", handleMouseUp);
    } else {
      window.removeEventListener("mousemove", handleMouseMove);
      window.removeEventListener("mouseup", handleMouseUp);
      window.removeEventListener("touchmove", handleMouseMove);
      window.removeEventListener("touchend", handleMouseUp);
    }
  
    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
      window.removeEventListener("mouseup", handleMouseUp);
      window.removeEventListener("touchmove", handleMouseMove);
      window.removeEventListener("touchend", handleMouseUp);
    };
  }, [dragging]);

  useEffect(() => {
    if (showCamera) {
        navigator.mediaDevices
            .getUserMedia({ video: true })
            .then((stream) => {
                if (videoRef.current) {
                    videoRef.current.srcObject = stream;
                    videoRef.current.play();
                }
            })
            .catch((error) => {
                console.error("Error accessing camera:", error);
                setAlert({
                    showAlert: true,
                    severity: "error",
                    message: "Unable to access camera. Please check permissions.",
                    header: "Camera Error",
                });
                setShowCamera(false);
            });
    }
  }, [showCamera]);

  // const handleMouseDown = (e) => {
  //   e.preventDefault();
  //   setDragging(true);
  
  //   const clientX = e.clientX || e.touches?.[0].clientX;
  //   const clientY = e.clientY || e.touches?.[0].clientY;
  
  //   const containerRect = containerRef.current.getBoundingClientRect();
  
  //   dragStartRef.current = {
  //     x: clientX - containerRect.left - position.x,
  //     y: clientY - containerRect.top - position.y,
  //   };
  // };
  
  const handleMouseMove = (e) => {
    if (!dragging || !containerRef.current) return;
  
    const clientX = e.clientX || e.touches?.[0].clientX;
    const clientY = e.clientY || e.touches?.[0].clientY;
  
    const containerRect = containerRef.current.getBoundingClientRect();
  
    const x = clientX - containerRect.left - dragStartRef.current.x;
    const y = clientY - containerRect.top - dragStartRef.current.y;
  
    setPosition({ x, y });
  };
  
  const handleMouseUp = () => {
    setDragging(false);
  };
  


  const handleConfirm = async (event, pinArray) => {
    const PIN = pinArray.join('');
    console.log("PIN entered:", PIN);

    let response;
    if (docname === "address" || docname === "document3") {
        setShowPinPad(false);
      response = await uploadPhoto(selectedBase64Image, doctype, selectedKYCType?.value, idNum, PIN, agent['User'].id, docname);
    } else {
        setShowPinPad(false);
      response = await uploadPhoto(selectedBase64Image, doctype, docname, idNum, PIN, agent['User'].id, docname);
    }

    // Wrong PIN check (using the exact error code from your example)
    if (response?.payload?.errorNo === "11387-1" || response?.payload?.callStatus === "0") {
      setAlert({
        showAlert: true,
        severity: "error",
        message: response?.payload?.msg || "Wrong PIN code. Please try again.",
        header: "PIN Error",
      });
      setShowPinPad(true); // Keep PinPad open for retry
      return;
    }

    // Success
    if (response?.callStatus === "1" || response?.Status === "1") {
      setAlert({
        showAlert: true,
        severity: "success",
        message: "Document uploaded successfully!",
        header: "Success",
      });
    } else {
      // Any other failure
      setAlert({
        showAlert: true,
        severity: "error",
        message: response?.payload?.msg || "Upload failed",
        header: "Error",
      });
    }

    setShowPinPad(false);
  };

    // const handleFileSelect = async (event) => {
    //     const img = event.target.files[0];
    //     console.log(img)
    //     // setSelectedFile(img);
    //     if (img) {
    //       if (docType === "Selfie") {
    //         const currentTime = new Date();
    //         const fileTime = new Date(img.lastModified);
      
    //         // Calculate the difference in minutes
    //         const timeDifference = (currentTime - fileTime) / 60000; // Convert ms to minutes
      
    //         if (timeDifference > 2) {
    //           setAlert({
    //             showAlert: true,
    //             severity: "error",
    //             message: "The selected image was captured more than 2 minutes ago. Please capture a new selfie.",
    //             header: "Invalid Selfie",
    //           });
    //           setShowCamera(false);
    //           return;
    //         }
    //       }

    //       const reader = new FileReader();
    //       reader.onload = async (e) => {
    //         const base64 = e.target.result;
    //         setSelectedBase64Image(base64);
    //         setRotation(0);
    //         setZoom(1);
    //         setPreviewDialogOpen(true); 
    //       }
    //       reader.readAsDataURL(img);
    //       setShowCamera(false);
    //     }

    //     if (fileInputRef.current) {
    //       fileInputRef.current.value = "";
    //     }
    //   };

    const handleFileSelect = (event) => {
      console.log("handleFileSelect=====================");
      const file = event.target.files?.[0]
      if (file) {
        if (docType === "Selfie") {
          const currentTime = new Date();
          const fileTime = new Date(file.lastModified);
    
          // Calculate the difference in minutes
          const timeDifference = (currentTime - fileTime) / 60000; // Convert ms to minutes
    
          if (timeDifference > 2) {
            setAlert({
              showAlert: true,
              severity: "error",
              message: "The selected image was captured more than 2 minutes ago. Please capture a new selfie.",
              header: "Invalid Selfie",
            });
            setShowCamera(false);
            return;
          }
        }

        const reader = new FileReader()
        // reader.onload = (e) => {
        //   setSelectedBase64Image(e.target?.result)
        //   setPreviewDialogOpen(true)
        //   // Reset values
        //   setZoom(1)
        //   setRotation(0)
        //   setPosition({ x: 0, y: 0 })
        //   setCropMode(false)
        //   setCropArea({ x: 150, y: 150, width: 300, height: 300 })
        // }

        reader.onload = (e) => {
          const base64Data = e.target?.result;
      
          setTempOriginalImage(base64Data);
          setSelectedBase64Image(base64Data);
          setPreviewDialogOpen(true);
          setZoom(1);
          setRotation(0);
          setPosition({ x: 0, y: 0 });
          setIsEditing(false); 
          setCropMode(false);
          setCropArea({ x: 150, y: 150, width: 300, height: 300 });
        };

        reader.readAsDataURL(file)
      }
    }

    // Handle image dragging (pan)
    // const handleMouseDown = useCallback(
    //   (e) => {
    //     if (cropMode) return // Don't allow panning in crop mode

    //     e.preventDefault()
    //     setDragging(true)

    //     const startX = e.touches ? e.touches[0].clientX : e.clientX
    //     const startY = e.touches ? e.touches[0].clientY : e.clientY
    //     const startPos = { ...position }

    //     const handleMouseMove = (moveEvent) => {
    //       const currentX = moveEvent.touches ? moveEvent.touches[0].clientX : moveEvent.clientX
    //       const currentY = moveEvent.touches ? moveEvent.touches[0].clientY : moveEvent.clientY

    //       const deltaX = currentX - startX
    //       const deltaY = currentY - startY

    //       setPosition({
    //         x: startPos.x + deltaX,
    //         y: startPos.y + deltaY,
    //       })
    //     }

    //     const handleMouseUp = () => {
    //       setDragging(false)
    //       document.removeEventListener("mousemove", handleMouseMove)
    //       document.removeEventListener("mouseup", handleMouseUp)
    //       document.removeEventListener("touchmove", handleMouseMove)
    //       document.removeEventListener("touchend", handleMouseUp)
    //     }

    //     document.addEventListener("mousemove", handleMouseMove)
    //     document.addEventListener("mouseup", handleMouseUp)
    //     document.addEventListener("touchmove", handleMouseMove)
    //     document.addEventListener("touchend", handleMouseUp)
    //   },
    //   [cropMode, position],
    // )

    const handleMouseDown = useCallback(
      (e) => {
        if (cropMode) return;
    
        e.preventDefault();
        setDragging(true);
    
        const clientX = e.touches ? e.touches[0].clientX : e.clientX;
        const clientY = e.touches ? e.touches[0].clientY : e.clientY;
    
        const containerRect = containerRef.current.getBoundingClientRect();
    
        dragStartRef.current = {
          x: clientX - containerRect.left - position.x,
          y: clientY - containerRect.top - position.y,
        };
      },
      [cropMode, position]
    );

    // Handle crop area dragging and resizing
    const handleCropMouseDown = useCallback(
      (e, action) => {
        if (!cropMode) return

        e.preventDefault()
        e.stopPropagation()

        const startX = e.clientX
        const startY = e.clientY
        const startCrop = { ...cropArea }

        setResizing(action)

        const handleMouseMove = (moveEvent) => {
          const deltaX = moveEvent.clientX - startX
          const deltaY = moveEvent.clientY - startY

          if (action === "move") {
            setCropArea((prev) => ({
              ...prev,
              x: Math.max(0, Math.min(600 - prev.width, startCrop.x + deltaX)),
              y: Math.max(0, Math.min(600 - prev.height, startCrop.y + deltaY)),
            }))
          } else if (action === "resize-se") {
            setCropArea((prev) => ({
              ...prev,
              width: Math.max(50, Math.min(600 - prev.x, startCrop.width + deltaX)),
              height: Math.max(50, Math.min(600 - prev.y, startCrop.height + deltaY)),
            }))
          } else if (action === "resize-nw") {
            const newWidth = Math.max(50, startCrop.width - deltaX)
            const newHeight = Math.max(50, startCrop.height - deltaY)
            const newX = Math.max(0, startCrop.x + startCrop.width - newWidth)
            const newY = Math.max(0, startCrop.y + startCrop.height - newHeight)

            setCropArea({
              x: newX,
              y: newY,
              width: newWidth,
              height: newHeight,
            })
          }
        }

        const handleMouseUp = () => {
          setResizing(null)
          document.removeEventListener("mousemove", handleMouseMove)
          document.removeEventListener("mouseup", handleMouseUp)
        }

        document.addEventListener("mousemove", handleMouseMove)
        document.addEventListener("mouseup", handleMouseUp)
      },
      [cropMode, cropArea],
    )

    const handleImageConfirm = async () => {
      const img = imageRef.current
      const container = containerRef.current
  
      // if (!img || !container) return

      if (
        !img ||
        !container ||
        !img.complete ||
        img.naturalWidth === 0 ||
        img.naturalHeight === 0
      ) {
        setAlert({
          showAlert: true,
          severity: "error",
          header: "Invalid Image",
          message: "The selected file could not be loaded as an image.",
        });
        setPreviewDialogOpen(false);
        return;
      }
  
      const canvas = document.createElement("canvas")
      const ctx = canvas.getContext("2d")
  
      if (!ctx) return
  
      if (cropMode) {
        // Set canvas size to exactly match crop area dimensions
        canvas.width = cropArea.width
        canvas.height = cropArea.height
  
        const natW = img.naturalWidth
        const natH = img.naturalHeight
        const containerCenterX = 300 // container width / 2
        const containerCenterY = 300 // container height / 2
  
        // Calculate the actual image bounds after transformations
        const imageScale = zoom
        const scaledWidth = natW * imageScale
        const scaledHeight = natH * imageScale
  
        // Calculate where the crop area intersects with the transformed image
        const imageLeft = containerCenterX + position.x - scaledWidth / 2
        const imageTop = containerCenterY + position.y - scaledHeight / 2
  
        // Calculate source coordinates on the original image
        const sourceX = Math.max(0, (cropArea.x - imageLeft) / imageScale)
        const sourceY = Math.max(0, (cropArea.y - imageTop) / imageScale)
        const sourceWidth = Math.min(natW - sourceX, cropArea.width / imageScale)
        const sourceHeight = Math.min(natH - sourceY, cropArea.height / imageScale)
  
        // Apply rotation if needed
        if (rotation !== 0) {
          ctx.save()
          ctx.translate(cropArea.width / 2, cropArea.height / 2)
          ctx.rotate((rotation * Math.PI) / 180)
          ctx.drawImage(
            img,
            sourceX,
            sourceY,
            sourceWidth,
            sourceHeight,
            -cropArea.width / 2,
            -cropArea.height / 2,
            cropArea.width,
            cropArea.height,
          )
          ctx.restore()
        } else {
          // Draw only the cropped portion
          ctx.drawImage(img, sourceX, sourceY, sourceWidth, sourceHeight, 0, 0, cropArea.width, cropArea.height)
        }
      } else {
        // Original functionality for full image
        const canvasSize = 600
        canvas.width = canvasSize
        canvas.height = canvasSize
  
        const natW = img.naturalWidth
        const natH = img.naturalHeight
        const scale = zoom
        const offsetX = position.x
        const offsetY = position.y
  
        ctx.save()
        ctx.translate(canvasSize / 2 + offsetX, canvasSize / 2 + offsetY)
        ctx.rotate((rotation * Math.PI) / 180)
        ctx.scale(scale, scale)
        ctx.drawImage(img, -natW / 2, -natH / 2)
        ctx.restore()
      }
  
      const transformedBase64 = canvas.toDataURL("image/png")
      setSelectedBase64Image(transformedBase64)
      setPreviewDialogOpen(false)
  
      // Your existing upload logic here
      console.log("Processed image==============");

      setSelectedBase64Image(transformedBase64);
      setPreviewDialogOpen(false);
      handleCameraClose();
  
      if (pin && pinConfiguration === "once") {
        if (docname === "address" || docname === "document3") {
          uploadPhoto(selectedBase64Image, doctype, selectedKYCType?.value, idNum, pin, agent['User'].id);

        }
        else {
          uploadPhoto(selectedBase64Image, doctype, docname, idNum, pin, agent['User'].id);
        }
      }
      else if (pinConfiguration === "never") {
        console.log("we are at never")
        if (docname === "address" || docname === "document3") {
          uploadPhoto(selectedBase64Image, doctype, selectedKYCType?.value, idNum, "0000", agent['User'].id);
        }
        else {
          uploadPhoto(selectedBase64Image, doctype, docname, idNum, "0000", agent['User'].id);
        }
      }
      else {
        setShowPinPad(true);
      }
    }

      // const handleImageConfirm = async() => {
      //   const img = imageRef.current;
      //   const container = containerRef.current;

      //   if (!img || !container) return;

      //   const canvasSize = 600; 
      //   const canvas = document.createElement("canvas");
      //   const ctx = canvas.getContext("2d");

      //   canvas.width = canvasSize;
      //   canvas.height = canvasSize;
      //   const natW = img.naturalWidth;
      //   const natH = img.naturalHeight;

      //   const scale = zoom;

      //   const offsetX = position.x;
      //   const offsetY = position.y;

      //   ctx.save();
      //   ctx.translate(canvasSize / 2 + offsetX, canvasSize / 2 + offsetY);
      //   ctx.rotate((rotation * Math.PI) / 180);
      //   ctx.scale(scale, scale);
      //   ctx.drawImage(img, -natW / 2, -natH / 2);
      //   ctx.restore();

      //   const transformedBase64 = canvas.toDataURL("image/png");
      //   setSelectedBase64Image(transformedBase64);
      //   setPreviewDialogOpen(false);

      //   if (pin && pinConfiguration === "once") {
      //     if (docname === "address" || docname === "document3") {
      //       uploadPhoto(selectedBase64Image, doctype, selectedKYCType?.value, idNum, pin, agent['User'].id);

      //     }
      //     else {
      //       uploadPhoto(selectedBase64Image, doctype, docname, idNum, pin, agent['User'].id);
      //     }
      //   }
      //   else if (pinConfiguration === "never") {
      //     console.log("we are at never")
      //     if (docname === "address" || docname === "document3") {
      //       uploadPhoto(selectedBase64Image, doctype, selectedKYCType?.value, idNum, "0000", agent['User'].id);
      //     }
      //     else {
      //       uploadPhoto(selectedBase64Image, doctype, docname, idNum, "0000", agent['User'].id);
      //     }
      //   }
      //   else {
      //     setShowPinPad(true);
      //   }
      // }

      const openFileSelectionDialog = () => {
        // fileInputRef.current.click();
        if (fileInputRef.current) {
          fileInputRef.current.click();
        }
      };

    useEffect(() => {
        if (selectedBase64Image && pin) {
          if (docname === "address" || docname === "document3") {
            uploadPhoto(selectedBase64Image, doctype, selectedKYCType?.value, idNum, pin, agent['User'].id);
          }
          else {
            uploadPhoto(selectedBase64Image, doctype, docname, idNum, pin, agent['User'].id);
          }
        }

        else if (pinConfiguration === "never") {
          if (docname === "address" || docname === "document3") {
            uploadPhoto(selectedBase64Image, doctype, selectedKYCType?.value, idNum, "0000", agent['User'].id);
          }
          else {
            uploadPhoto(selectedBase64Image, doctype, docname, idNum, "0000", agent['User'].id);
          }
        }

    }, [selectedBase64Image]);

    const handleIdChange = (event) => {
        setIdNum(event.target.value);
    }

    const handleDocumentTypeChange = (event) => {
        setNewDocType(event.target.value);
    };

    // console.log(docType)

    const openCamera = () => {
      if (cameraTimeout) clearInterval(cameraTimeout);
      setShowCamera(true);
      navigator.mediaDevices
        .getUserMedia({ video: { facingMode: facingMode } })
        // .getUserMedia({ video: true })
        .then((stream) => {
          if (videoRef.current) {
            videoRef.current.srcObject = stream;
            
            // Play returns a promise, we should catch interruptions
            const playPromise = videoRef.current.play();

            if (playPromise !== undefined) {
                playPromise.then(() => {
                    // Playback started successfully
                }).catch(error => {
                    // Auto-play was prevented or interrupted
                    console.log("Playback interrupted or prevented:", error);
                });
            }
          }
        })
        .catch((error) => {
          console.error("Error accessing camera:", error);
          setAlert({
            showAlert: true,
            severity: "error",
            message: "Unable to access camera. Please check permissions.",
            header: "Camera Error",
          });
      });

      // Reset countdown
      setCountdown(120);

      // Start countdown timer
      const timer = setInterval(() => {
        setCountdown((prev) => {
          if (prev <= 1) {
            clearInterval(timer);
            handleCameraClose();
            setAlert({
              showAlert: true,
              severity: "warning",
              message: "Camera timeout. Please try again.",
              header: "Timeout",
            });
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
  
        setCameraTimeout(timer);
    };

    const toggleCamera = () => {
      const newMode = facingMode === "user" ? "environment" : "user";
      setFacingMode(newMode);
  
      // Stop current stream to release the camera hardware
      if (videoRef.current && videoRef.current.srcObject) {
        videoRef.current.srcObject.getTracks().forEach((track) => track.stop());
      }
  
      // Clear interval before restarting
      if (cameraTimeout) clearInterval(cameraTimeout);
  
      // Restart with the new mode
      setTimeout(() => {
        openCamera();
      }, 100);
    };

    // const handleCapture = () => {
    //   const canvas = canvasRef.current;
    //   const video = videoRef.current;
    //   const context = canvas.getContext("2d");
  
    //   canvas.width = video.videoWidth;
    //   canvas.height = video.videoHeight;
    //   context.drawImage(video, 0, 0, canvas.width, canvas.height);
  
    //   const imageData = canvas.toDataURL("image/png");
    //   console.log(imageData);
    //   setSelectedBase64Image(imageData);
  
    //   handleCameraClose();
    //   setShowPinPad(true);
    // };

    const handleCapture = () => {
      const canvas = canvasRef.current;
      const video = videoRef.current;
      const context = canvas.getContext("2d");
  
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      context.drawImage(video, 0, 0, canvas.width, canvas.height);
  
      const imageData = canvas.toDataURL("image/png");
  
      // 1. Save the original image to our backup state
      setTempOriginalImage(imageData);
      
      // 2. Set the image for display
      setSelectedBase64Image(imageData);
  
      // 3. Close camera and open the Preview Dialog
      handleCameraClose();
      setIsEditing(false); // Start in "Static/Full View" mode
      setPreviewDialogOpen(true); 
    };
  
    const handleCameraClose = () => {
      if (cameraTimeout) {
        clearInterval(cameraTimeout);
      }
      setShowCamera(false);
      if (videoRef.current && videoRef.current.srcObject) {
        let stream = videoRef.current.srcObject;
        let tracks = stream.getTracks();
  
        tracks.forEach((track) => track.stop());
        videoRef.current.srcObject = null;
      }
    };


    useEffect(() => {
      console.log("SelectedKYCType state:", selectedKYCType);
    }, [selectedKYCType]);

    // console.log(docname)

    const isCaptureDisabled = (docname === "address" || docname === "document3") 
    ? (!selectedKYCType || selectedKYCType.value === "select" || Object.keys(selectedKYCType).length === 0) 
    : false;
    
    return (
        <>
        <Box  className="kyc-item" sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <Box className="kyc-input">
            {/* <Typography variant="h9" className="classification">Classification</Typography> */}
            {docname === "address" || docname === "document3" ? (
              <Autocomplete
              key={docname}
              value={selectedKYCType || null}
              onChange={(e, newValue) => {
                setSelectedKYCType(newValue);
              }}
              disabled={docname === "selfie" || docname === "passport"}
              options={kycTypes}
              getOptionLabel={(option) => option.label}
              isOptionEqualToValue={(option, value) => option.value === value}
              getOptionDisabled={(option) => 
                option.value === "passport" || option.value === "selfie" // Add conditions to disable options
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  InputProps={{
                    ...params.InputProps,
                    sx: {
                      padding: "0",   // Remove extra padding
                      alignItems: "center", // Center the arrow
                    },
                  }}
                  sx={{
                    width: "215px", // Control width
                    alignItems: "center", // Center the arrow
                    marginRight: "10px",
                    fontSize: "12px",
                    "& .MuiOutlinedInput-root": {
                      height: "40px", // Match the input field height
                      alignItems: "center", // Center the arrow
                      fontSize: "12px",
                      paddingLeft: "12px",
                    },
                    "& .MuiAutocomplete-endAdornment": {
                      top: "20%", // Align arrow vertically
                      right: "8px", // Adjust horizontal position
                    },
                  }}
                />
              )}
            />)
            :
            (
              <Box className="kyc-type">
                <Typography variant="h9" 
                  className="docType"
                  sx={{
                    color: "#000",
                    fontFamily: "Inter",
                    fontSize: "12px",
                    fontStyle: "normal",
                    fontWeight: 400,
                    lineHeight: "40px",
                    paddingLeft: "16px",
                    paddingTop: "6px",
                    paddingBottom: "6px",
                  }}
                >
                  {docType}
                </Typography>
            </Box>
            )
            }
            </Box>
            <input type="file" accept="image/*" onChange={handleFileSelect} style={{ display: "none" }} ref={fileInputRef} />
            {docType !== 'Selfie' && (
              <>
                  <Button 
                      className="capture-button" 
                      onClick={openCamera}
                      sx={{
                          textTransform: "capitalize",
                      }}
                    //   disabled={uploadLoading}
                      disabled={uploadLoading || isCaptureDisabled}
                  >
                      {uploadLoading ? "Taking..." : "Take Photo"}
                  </Button>
              </>
            )}
            <Button 
              className="upload-button" 
              onClick={() => {
                // Reset the file input value before opening the dialog
                fileInputRef.current.value = '';
                docType !== "Selfie" ? openFileSelectionDialog() : openCamera();
              }}
              sx={{
                textTransform: "capitalize",
              }}
            //   disabled={uploadLoading}
              disabled={uploadLoading || isCaptureDisabled}
            >
              {uploadLoading ? "Uploading..." : "Upload"}
            </Button>
            {docType === 'Identification' && 
            <>
                <select 
                    value={newDocType}
                    onChange={handleDocumentTypeChange}
                    className="identification-kyc-select"
                >
                    <option value="">Select Document Type</option>
                    <option value="SA_ID">South African ID</option>
                    <option value="Passport">Passport</option>
                    <option value="Refugee_ID">Refugee Documentation</option>
                    <option value="Aslyum_permit">Asyulm Permit</option>
                </select>
                <input className="identification-kyc-id" type="text" placeholder="Document ID Number" onChange={handleIdChange}/>
            </>
          }
            
        </Box>
        <CustomAlert 
          severity={alert.severity} 
          show={alert.showAlert} 
          header={alert.header} 
          message={alert.message} 
          onClick={(prevDetails) => setAlert({...prevDetails, showAlert: false})} 
          autoclose={alert.severity === "error" ? false : true} 
        />
        {showPinPad && 
          <PinPad 
            show={showPinPad} 
            handleConfirm={handleConfirm} 
            onClick={() => setShowPinPad(false)} 
          />
        }

        {/* Camera Modal */}
        <Dialog open={showCamera} onClose={handleCameraClose} fullWidth maxWidth="sm">
        <IconButton
            aria-label="close"
            onClick={handleCameraClose}
            sx={{
                position: 'absolute',
                right: 8,
                top: 8,
                color: (theme) => theme.palette.grey[500],
                zIndex: 1, // Ensures it stays above the video
                background: "#ffffff",
                borderRadius: "50px"
            }}
        >
            <CloseIcon />
        </IconButton>
          <DialogContent>
            <video ref={videoRef} style={{ width: "100%", height: "auto" }} />
            <canvas ref={canvasRef} style={{ display: "none" }} />
            <Typography
            variant="h6"
            sx={{
              fontStyle: "normal",
              fontWeight: 400,
              fontSize: "20px",
              lineHeight: "25px",
              textAlign: "center",
              marginTop: 2,
              color: "#DC3545", // Red for urgency
              fontFamily: "Nunito",
            }}
          >
            Time Remaining: {Math.floor(countdown / 60)}:{String(countdown % 60).padStart(2, "0")}
          </Typography>
          </DialogContent>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Divider sx={{ my: 2, border: "1px solid #A6A6A6", width: "70%" }} />
          </Box>
          <DialogActions
            sx={{
              display: "flex",
              justifyContent: "center", // Centers the buttons horizontally
              alignItems: "center", // Ensures vertical alignment
              gap: 3, // Adds spacing between buttons
              flexDirection: "space-between",
              marginBottom: "30px"
            }}
          >
              <Button
                variant="contained"
                onClick={handleCapture}
                startIcon={<img src={captureImage} alt="Capture Icon" style={{ width: "20px", height: "20px" }} loading="lazy" />}
                sx={{
                  backgroundColor: "#007BFF", // Blue background
                  color: "#FFF", // White text
                  padding: "10px 20px", // Add padding for larger buttons
                  borderRadius: "8px", // Rounded corners
                  textTransform: "none", // Keep original text case
                  fontSize: "16px", // Increase font size
                  fontWeight: 600,
                  fontFamily: "Nunito",
                  "&:hover": {
                    backgroundColor: "#0056b3", // Darker blue on hover
                  },
                }}
              >
                Take Photo Now
              </Button>

              <Button
                variant="outlined"
                onClick={toggleCamera}
                sx={{ color: "#007BFF", borderColor: "#007BFF", fontWeight: 600 }}
              >
                  Switch Camera
              </Button>

              {(docname == "selfie" || docname == "Selfie")  && <Button
                variant="contained"
                onClick={openFileSelectionDialog}
                startIcon={<img src={uploadImage} alt="Upload Icon" style={{ width: "20px", height: "20px" }} loading="lazy" />}
                sx={{
                  backgroundColor: "#003366", // Dark blue background
                  color: "#FFF", // White text
                  padding: "10px 20px", // Add padding for larger buttons
                  borderRadius: "8px", // Rounded corners
                  textTransform: "none", // Keep original text case
                  fontSize: "16px", // Increase font size
                  fontWeight: 600,
                  fontFamily: "Nunito",
                  "&:hover": {
                    backgroundColor: "#002244", // Darker shade on hover
                  },
                }}
              >
                Upload Selfie
              </Button>}
          </DialogActions>
        </Dialog>

        <Dialog open={previewDialogOpen} onClose={() => setPreviewDialogOpen(false)} maxWidth="md" fullWidth>
        <DialogContent sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
          {/* Crop Mode Toggle */}
          {/* <Box sx={{ mb: 2 }}>
            <Chip
              icon={<Crop />}
              label={cropMode ? "Exit Crop Mode" : "Crop Mode"}
              onClick={() => setCropMode(!cropMode)}
              color={cropMode ? "primary" : "default"}
              variant={cropMode ? "filled" : "outlined"}
            />
          </Box> */}

          {/* Image Container */}
          <Box
            ref={containerRef}
            sx={{
              width: 600,
              height: 600,
              border: "2px solid #d3d3d3",
              borderRadius: "12px",
              backgroundColor: "#fefefe",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              overflow: "hidden",
              position: "relative",
              cursor: cropMode ? "crosshair" : dragging ? "grabbing" : "grab",
            }}
          >
            {selectedBase64Image && (
              <>
                <Box
                  component="img"
                  src={selectedBase64Image}
                  alt="Preview"
                  ref={imageRef}
                  onMouseDown={handleMouseDown}
                  onTouchStart={handleMouseDown}
                  draggable={false}
                  sx={{
                    cursor: cropMode ? "crosshair" : dragging ? "grabbing" : "grab",
                    transform: `translate(${position.x}px, ${position.y}px) scale(${zoom}) rotate(${rotation}deg)`,
                    transition: dragging || resizing ? "none" : "transform 0.3s ease-in-out",
                    userSelect: "none",
                    position: "absolute",
                  }}
                />

                {/* Crop Overlay */}
                {cropMode && (
                  <>
                    {/* Dark overlay */}
                    <Box
                      sx={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: "rgba(0, 0, 0, 0.5)",
                        pointerEvents: "none",
                      }}
                    />

                    {/* Crop area */}
                    <Box
                      sx={{
                        position: "absolute",
                        left: cropArea.x,
                        top: cropArea.y,
                        width: cropArea.width,
                        height: cropArea.height,
                        border: "2px solid white",
                        cursor: "move",
                        "&::before": {
                          content: '""',
                          position: "absolute",
                          top: 0,
                          left: 0,
                          right: 0,
                          bottom: 0,
                          border: "1px dashed rgba(255, 255, 255, 0.5)",
                        },
                      }}
                      onMouseDown={(e) => handleCropMouseDown(e, "move")}
                    >
                      {/* Resize handles */}
                      <Box
                        sx={{
                          position: "absolute",
                          top: -4,
                          left: -4,
                          width: 8,
                          height: 8,
                          backgroundColor: "white",
                          border: "1px solid #666",
                          cursor: "nw-resize",
                        }}
                        onMouseDown={(e) => handleCropMouseDown(e, "resize-nw")}
                      />
                      <Box
                        sx={{
                          position: "absolute",
                          bottom: -4,
                          right: -4,
                          width: 8,
                          height: 8,
                          backgroundColor: "white",
                          border: "1px solid #666",
                          cursor: "se-resize",
                        }}
                        onMouseDown={(e) => handleCropMouseDown(e, "resize-se")}
                      />
                    </Box>
                  </>
                )}
              </>
            )}
          </Box>

          {/* Controls */}
          <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", marginTop: 3, width: "80%" }}>
            <Typography variant="body2" gutterBottom sx={{ fontFamily: "Nunito", fontWeight: 600 }}>
              <ZoomIn sx={{ mr: 1, verticalAlign: "middle" }} />
              Zoom Level
            </Typography>
            <Slider
              value={zoom}
              min={0.2}
              max={3}
              step={0.1}
              onChange={(e, value) => setZoom(value)}
              sx={{ width: "100%" }}
              valueLabelDisplay="auto"
            />
            <Box sx={{ display: "flex", justifyContent: "center", gap: 2, marginTop: 2 }}>
              <Button variant="outlined" onClick={() => setRotation((r) => r - 90)} startIcon={<RotateLeft />}>
                Rotate Left
              </Button>
              <Button variant="outlined" onClick={() => setRotation((r) => r + 90)} startIcon={<RotateRight />}>
                Rotate Right
              </Button>
              {/* Crop Mode Toggle */}
              <Button variant="outlined" onClick={() => setCropMode(!cropMode)} startIcon={<Crop />}>
                {cropMode ? "Exit Crop Mode" : "Crop Mode"}
              </Button>
            </Box>
          </Box>
        </DialogContent>

        <DialogActions sx={{ justifyContent: "center", gap: 2, paddingBottom: 2 }}>
          <Button variant="contained" color="primary" onClick={handleImageConfirm}>
            Confirm
          </Button>
          <Button
            variant="outlined"
            onClick={() => {
              setPreviewDialogOpen(false)
              setSelectedBase64Image(null)
            }}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>

        {/* <Dialog open={previewDialogOpen} onClose={() => setPreviewDialogOpen(false)} maxWidth="md" fullWidth>
        <DialogContent sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <Box
            ref={containerRef}
            sx={{
              width: 600,
              height: 600,
              border: '2px solid #d3d3d3',
              borderRadius: '12px',
              backgroundColor: '#fefefe',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              overflow: 'hidden',
              position: 'relative',
            }}
          >
            {selectedBase64Image && (
              <Box
                component="img"
                src={selectedBase64Image}
                alt="Preview"
                ref={imageRef}
                onMouseDown={handleMouseDown}
                onTouchStart={handleMouseDown}
                draggable={false}
                sx={{
                  cursor: dragging ? 'grabbing' : 'grab',
                  transform: `translate(${position.x}px, ${position.y}px) scale(${zoom}) rotate(${rotation}deg)`,
                  transition: dragging ? 'none' : 'transform 0.3s ease-in-out',
                  userSelect: 'none',
                  position: 'absolute', 
                }}
              />
            )}
          </Box>
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: 3, width: '80%' }}>
            <Typography variant="body2" gutterBottom sx={{ fontFamily: 'Nunito', fontWeight: 600 }}>
              Zoom Level
            </Typography>
            <Slider
              value={zoom}
              min={0.5}
              max={3}
              step={0.1}
              onChange={(e, value) => setZoom(value)}
              sx={{ width: '100%' }}
              valueLabelDisplay="auto"
            />
            <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2, marginTop: 2 }}>
              <Button variant="outlined" onClick={() => setRotation((r) => r - 90)}>Rotate Left</Button>
              <Button variant="outlined" onClick={() => setRotation((r) => r + 90)}>Rotate Right</Button>
            </Box>
          </Box>
        </DialogContent>

          <DialogActions sx={{ justifyContent: 'center', gap: 2, paddingBottom: 2 }}>
            <Button variant="contained" color="primary" onClick={() => {
              handleImageConfirm();
            }}>
              Confirm
            </Button>
            <Button variant="outlined" onClick={() => {
              setPreviewDialogOpen(false);
              setSelectedBase64Image(null);
            }}>
              Cancel
            </Button>
          </DialogActions>
        </Dialog> */}
        </>
    );
}

export default KYCNoItem;